// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d00b2310","513":"58ae5eca","787":"09b814fd"}[chunkId] + ".chunk.js";
};